import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import toast from "react-hot-toast";
import ReportService from "../services/ReportService";
import { useBrand } from "./../helper/BrandContext";

const Mappingrpt = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const reportService = new ReportService();
  const surveyLink = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    brandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: ""
  });
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);

  function GetMappingRpt() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    reportService
      .getMapping(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (
      (name === "FromDate" || name === "ToDate") &&
      !(value instanceof Date)
    ) {
      toast.error(
        `Please select a valid ${name === "FromDate" ? "from" : "to"} date.`
      );
      return;
    }

    if (name === "FromDate" && value > state.ToDate) {
      toast.error("From date must be less than to date.");
      return;
    }

    if (name === "ToDate" && value < state.FromDate) {
      toast.error("To date must be greater than from date.");
      return;
    }

    setState((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const FilterData = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.FromDate = state.FromDate.toLocaleDateString();
    tableRequest.ToDate = state.ToDate.toLocaleDateString();
    GetMappingRpt();
  };

  const GetReportExport = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.PageSize = -1;
    reportService
      .getMapping(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const filteredData = data.responseData.map((item) => ({
            productName: item.productName,
            sapCode: item.sapCode,
            mrp: item.mrp,
            fromNo: item.fromNo,
            toNo: item.toNo,
            qty: item.qty,
            batchNo: item.batchNo,
            itemBatchsize: item.itemBatchsize,
            dateManufactur: item.dateManufactur,
            dateExpiry: item.dateExpiry,
            createdDate: item.createdDate,
            username: item.username,
            location: item.location
          }));

          setState((prevData) => ({
            ...prevData,
            allData: filteredData,
            loading: false
          }));

          setTriggerDownload(true);
          // Trigger the CSV download
        } else {
          setState((prevData) => ({
            ...prevData,
            allData: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to export data");
      });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    //GetMappingRpt();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetMappingRpt();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetMappingRpt();
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    var date = new Date();
    date.setDate(date.getDate() - 6);
    tableRequest.FromDate = date.toLocaleDateString();
    tableRequest.ToDate = new Date().toLocaleDateString();
    setState((prevData) => ({
      ...prevData,
      FromDate: date,
      ToDate: new Date()
    }));
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      GetMappingRpt();
    }
  }, [brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Mapping Report
        </h1>
      </div>
      <div className="date-picker-container flex items-center mb-4 md:mb-0">
        <Calendar
          value={state.FromDate || undefined}
          name="FromDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm mr-2"
        />
        <Calendar
          value={state.ToDate || undefined}
          name="ToDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm mr-2"
        />
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <button
          type="button"
          onClick={FilterData}
          className="ml-3 mr-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <button
          target="_blank"
          disabled={!state.sales.length}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={GetReportExport}
        >
          Export
        </button>
        <CSVLink
          hidden={true}
          data={state.allData}
          ref={surveyLink}
          filename={"Mapping Report.csv"}
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <DataTable
              exportFilename="Mapping Report"
              responsive={true}
              header={header}
              globalFilter={state.globalFilter}
              emptyMessage={state.emptyMessage}
              value={state.sales}
              paginator={true}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rows={state.rows}
              rowsPerPageOptions={[10, 50, 200, 500]}
              totalRecords={state.totalRecords}
              lazy={true}
              first={state.first}
              onPage={onPage}
              onSort={onSort}
              className="p-datatable-responsive"
              scrollable={true} // Add this line to enable horizontal scrolling
            >
              <Column
                field="username"
                header="User Name"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="productName"
                header="Product Name"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="sapCode"
                header="Sap Code"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="mrp"
                header="MRP"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="fromNo"
                header="From No"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="toNo"
                header="To No"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="qty"
                header="Quantity"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="batchNo"
                header="Batch Number"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="itemBatchsize"
                header="Batch Size"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="dateManufactur"
                header="Mfg. Date"
                sortable={true}
                style={{ width: "100px" }}
              />
              <Column
                field="dateExpiry"
                header="Expiry Date"
                sortable={true}
                style={{ width: "100px" }}
              />
              <Column
                field="createdDate"
                header="Created Date"
                sortable={true}
                style={{ width: "100px" }}
              />
              <Column
                field="location"
                header="User Location"
                sortable={false}
                style={{ width: "100px" }}
              />
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default Mappingrpt;
